import {
  defaultDataIdFromObject,
  InMemoryCache,
  type PossibleTypesMap,
  type TypePolicies,
} from "@apollo/client/cache"
import {
  dataSource,
  employee,
  entityParty,
  firmClient,
  layout,
  objectAcl,
  objectMapping,
  queries,
  reportPackage,
  reportPackageDocument,
  searchResult,
  team,
  teamMember,
  threads,
  transaction,
  transactionParty,
  transactionsWithSummaries,
  vaultFields,
  workItem,
} from "src/shared/initializers/typePolicies"
import { department } from "src/shared/initializers/typePolicies/department"

const typePolicies: TypePolicies = {
  Query: {
    fields: {
      ...queries,
    },
  },
  ...objectAcl,
  ...teamMember,
  ...team,
  ...employee,
  ...firmClient,
  ...transaction,
  ...transactionParty,
  ...transactionsWithSummaries,
  ...threads,
  ...searchResult,
  ...entityParty,
  ...reportPackage,
  ...reportPackageDocument,
  ...layout,
  ...workItem,
  ...dataSource,
  ...vaultFields,
  ...objectMapping,
  ...department,
}

const possibleTypes: PossibleTypesMap = {
  MetricTerm: ["MetricCategoriesOperand", "MetricSummaryTypeOperand", "MetricOperation"],
}

export const cache = new InMemoryCache({
  typePolicies,
  possibleTypes,
  dataIdFromObject: (object) => {
    switch (object.__typename) {
      case "InvoiceDiscount":
        return `InvoiceDiscount:${object.invoiceDiscountId}`
      case "BankAccount":
        return `BankAccount:${object.id}:${object.isDefault}:${object.isAutoPayout}`
      case "Check":
        return `Check:${object.id}:${object.isDefault}:${object.isAutoPayout}`
      // Turn off caching for specific types
      // Category is included here to address a hierarchy rendering issue.
      case "Category":
      case "CategoryTransactionSummary":
      case "QuickBooksIntegration":
      case "User":
      case "InvoicingProfile":
      case "Customer":
      case "CustomerSummary":
      case "CustomerAddress":
      case "InvoicingAddress":
      case "Discount":
      case "VendorSummary":
      case "ScheduleEditedObject":
      case "ScheduleSnapshot":
        return undefined
      default:
        return defaultDataIdFromObject(object)
    }
  },
})
